export { default, links, meta } from "/home/nevus/Hacktoberfest/jsonhero-web/app/root.tsx";